// extracted by mini-css-extract-plugin
export default {"hightlightWrapper":"CircleOccupancyHighlight_hightlightWrapper__z5zkE"};